#import "../fragments/inbound-whatsapp-rules-fragment.graphql"

query GetInboundWhatsAppRules {
    inboundWhatsAppRules {
        ...InboundWhatsAppRulesFragment
    }
}
